var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"placement":"right","content":_vm.option.description}},[_c('button',{class:_vm.buttonClass,on:{"click":function($event){_vm.editingSource = _vm.option.value}}},[_vm._v("\n  "+_vm._s(_vm.option.label)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }